export type WorkspaceTheme = "green" | "teal" | "purple" | "burgundy";

/** Admin pages keep the admin accent; round application work stays green. */
export function getWorkspaceTheme(path: string): WorkspaceTheme {
  const pathname = path.split(/[?#]/)[0];
  if (/^\/admin(?:\/|$)/.test(pathname)) return "burgundy";
  if (
    /^\/(application-builder|applications|forms|applicant|apply)(?:\/|$)/.test(
      pathname,
    ) ||
    /^\/round\/[^/]+\/(applications(?:\/|$)|admin\/proposal-forms(?:\/|$))/.test(
      pathname,
    )
  )
    return "green";
  if (
    /^\/round\/[^/]+\/(funder|funding-flow|settings\/funder)(?:\/|$)/.test(
      pathname,
    )
  )
    return "purple";
  if (/^\/round\/[^/]+(?:\/|$)/.test(pathname)) return "teal";
  return "green";
}
